export default __webpack_public_path__ + "static/media/noytrall-logo.1c2de738.svg";